import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import constants from 'common/helpers/constants'
import { FormattedMessage } from 'sb-react-intl'

import Offers from 'components/Offers/Offers'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'
import s from './ChooseGiftSizeModal.scss'


class ChooseGiftSizeModal extends Component {

  static propTypes = {
    data: PropTypes.shape({
      onNext: PropTypes.func.isRequired,
    }),
    name: PropTypes.string,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    name: constants.modals.gifts.ChooseGiftSize,
  }

  handleClose = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  handleChooseOffer = ({ size, price }) => {
    const { data: { onNext } } = this.props

    this.handleClose()
    onNext({ size, price })
  }

  render() {
    const { name, giftSizes } = this.props

    return (
      <Modal className={s.chooseGiftSizeModal} name={name} onClose={this.handleClose}>
        <FormattedMessage className={s.title} tag="div" {...messages.title} />
        <Offers
          className={s.offers}
          placement="giftSize"
          items={giftSizes}
          bestSize={12}
          onChoose={this.handleChooseOffer}
        />
      </Modal>
    )
  }
}


export default connect({
  giftSizes: 'view.giftPage.giftSizes',
})(ChooseGiftSizeModal)
